// extracted by mini-css-extract-plugin
module.exports = {"useCurrentLanguage":"hooks_useCurrentLanguage__2WeRl","languageList":"hooks_languageList__3SKva","actions":"hooks_actions__1pKxK","comingSoon":"hooks_comingSoon__2dyZD"};